import { useMemo } from 'react';
import type { WorkingHours } from '@elfsight/widget-business-hours';
import { useSettings } from '@wu/widget-core';
import { compareAsc, max, min } from 'date-fns';

export interface SettingsSpecialInterval {
  id: string;
  dates: [Date, Date];
  settingsHours: WorkingHours[];
  isClosed: boolean;
  description: string;
}

export function useSettingsSpecialIntervals(): SettingsSpecialInterval[] {
  const { specialIntervals } = useSettings();

  return useMemo(
    () =>
      specialIntervals
        .flatMap((day) => {
          const endDate = max([
            new Date(`${day.startDate.date}T00:00`),
            new Date(`${day.endDate.date}T00:00`)
          ]);
          const startDate = min([
            new Date(`${day.startDate.date}T00:00`),
            new Date(`${day.endDate.date}T00:00`)
          ]);

          return {
            id: day.id,
            dates: [startDate, endDate] as [Date, Date],
            settingsHours: day.type === 'closed' ? [] : day.workingHours || [],
            isClosed: day.type === 'closed',
            description: day.description
          };
        })
        .sort((a, b) => compareAsc(a.dates[0], b.dates[0])),
    [specialIntervals]
  );
}
